import { usePage } from '@/components/providers/PageProvider'
import { getFilterCount } from '@/utils/routeUtil'

import { IconAdvancedRoot } from '../IconAdvancedRoot/IconAdvancedRoot'

export const IconAdvancedFilters = () => {
  const { page } = usePage()

  const route = page?.route
  const count = getFilterCount(route)

  return <IconAdvancedRoot count={count} variant='filters' />
}
